<cass-core-toolbar></cass-core-toolbar>
<div class='page-container'>
	<mat-card class="branding--title-card">
		<mat-card-content>
			<h1>
				{{ titleKey | translate }}
				<div class="section-card-button-container">
					<!-- <app-customer-list-filter></app-customer-list-filter> -->
				</div>
			</h1>
		</mat-card-content>
	</mat-card>
	<app-customers-list choose [chooseAgency]="chooseAgency" expand [customers$]="customers$" [showToolsPanel]="true" (customerSelected)="customerSelected($event)"></app-customers-list>
</div>
